/**
 * @lodex-pro/web-admin — Account page (quick 260827-pwd).
 *
 * Houses the voluntary password change for a signed-in platform admin.
 *
 * Admins deliberately have NO forgot-password affordance — they are
 * Paelode-provisioned and ops-reset, and a self-service reset would mean anyone
 * controlling that inbox can take the account (see the note in auth/SignInPage).
 * Changing a password you already know, while already authenticated, is a
 * different question with a different answer: `updatePassword` requires the
 * current password and the caller already holds a valid session, so it grants no
 * capability they lack. Withholding it would force an admin who suspects
 * compromise to ask someone else to rotate it, which is worse security.
 */

import * as React from 'react';
import { ChangePassword } from '@lodex-pro/web-shared';

export function AccountPage(): React.JSX.Element {
  return (
    <div style={{ padding: '24px', maxWidth: '640px' }}>
      <h1 style={{ fontSize: '20px', fontWeight: 600, marginBottom: '4px' }}>Account</h1>
      <p
        style={{
          fontSize: '13px',
          color: 'var(--color-text-secondary)',
          marginBottom: '16px',
        }}
      >
        Change the password you use to sign in to the admin console.
      </p>
      <div className="auth-card-inline">
        <ChangePassword />
      </div>
    </div>
  );
}
